import React from 'react'
import { Loader } from '../../../common/Loader'
import { Loading } from '../../../common/Loading'
import { Tabs } from '../../../common/Tabs'
import { LoaderContainer, TabsItemStyle, TabsListStyle } from '../styled'
import { QuantityAccordion } from './components/QuantityAccordion'
import * as S from './styled'
import type { MOQPricingData, Props } from './types'

export const MOQPricing = ({
  accordionState,
  data,
  includeFeesValue,
  isLoading,
  soldValue,
  soldValueError,
  onAccordionChange,
  onSoldValueChange,
}: Props) => {
  const renderAccordion = (data: MOQPricingData, isFirstTab = true) => {
    if (!data?.quantityPricing) {
      return (
        <LoaderContainer>
          <Loader size="large" />
        </LoaderContainer>
      )
    }

    return (
      <Loading isLoading={isLoading}>
        <QuantityAccordion
          accordionState={accordionState}
          autoAdjustedSellingPrice={!isFirstTab}
          includeFeesValue={includeFeesValue}
          data={data}
          soldValue={soldValue}
          soldValueError={soldValueError}
          onChange={onAccordionChange}
          onSoldValueChange={onSoldValueChange}
        />
      </Loading>
    )
  }

  const renderSizeTabs = () => (
    <Tabs>
      <S.TabsListContainer>
        <Tabs.List style={TabsListStyle}>
          {data?.map((tab) => (
            <Tabs.Item key={tab.label} style={TabsItemStyle} name={tab.label} variant="dimmed" />
          ))}
        </Tabs.List>
      </S.TabsListContainer>
      {data?.map((tab, index) => (
        <Tabs.Panel key={`${tab.label}-${index}`}>
          {renderAccordion(data[index], index === 0)}
        </Tabs.Panel>
      ))}
    </Tabs>
  )

  const renderContent = () => {
    if (data.length > 1) {
      return renderSizeTabs()
    }

    return (
      <>
        <S.Separator />
        {renderAccordion(data[0])}
      </>
    )
  }

  return <S.Container>{renderContent()}</S.Container>
}
